export default {
  name: 'gmk-wob'
};
